import { Box, Container, Link, Paper, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation();
  const settings = useSelector(
    (state: any) => state.settings?.internalSettings
  );
  const version = settings?.version;
  const userGuideURL = settings?.userGuideURL;

  return (
    <Paper className="footer" component="footer" square variant="outlined">
      <Container maxWidth="lg">
        <Stack spacing={6} direction="row">
          <Box
            sx={{
              flexGrow: 1,
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Stack direction="column">
              <Typography sx={{ fontSize: "0.9rem"}} variant="caption">
                <Link 
                  rel="noopener noreferrer" 
                  target="_blank" 
                  underline="hover" 
                  href={userGuideURL}>
                    {t("userGuideLink")}
                </Link>
              </Typography>
              <Typography sx={{ color: "gray" }} variant="caption">
                eFrikort. Version:
              </Typography>
              <Typography sx={{ color: "gray" }} variant="caption">
                {version}
              </Typography>
          
            </Stack>
          </Box>
        </Stack>
      </Container>
    </Paper>
  );
}
